import { getDicts } from '@/api'

/**
 * 获取字典数据
 */
export function useDict(...args) {
  const res = []
  return (() => {
    args.forEach(d => {
      res[d] = [];
      getDicts(d).then(resp => {
        res[d] = resp.data.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass }))
      })
    })
    return res;
  })()
}